<template>
  <div>
    <div class="gradient-background"></div>
    <div class="dashboard-wrapper" v-if="isLoaded">
      <!-- <DashboardGraph></DashboardGraph> -->
      <DashboardBanner :isMobile="isMobile" class="pt-7"></DashboardBanner>
      <DashboardPripady></DashboardPripady>
      <!-- <DashboardSablony></DashboardSablony> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DashboardGraph from '../components/dashboard/DashboardGraph';
import DashboardBanner from '../components/dashboard/DashboardBanner';
import DashboardPripady from '../components/dashboard/DashboardPripady';
import DashboardSablony from '../components/dashboard/DashboardSablony.vue';

export default {
  components: {
    DashboardGraph,
    DashboardBanner,
    DashboardPripady,
    DashboardSablony,
  },
  computed: {
    ...mapGetters('auth', ['isLoaded']),
    ...mapGetters(['isMobile']),
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
